/*
 * Licensed Materials - Property of IBM
 * IBM Business Analytics (C) Copyright IBM Corp. 2019, 2020
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */

define([], () => {
	/**
	 * @interface InternalModelsAPI
	 * @hideconstructor
	 * @classdesc API class that is used to retrieve the widgetModel and
	 * layoutModel from a content
	 */
	class InternalModelsAPI {

		/**
		 * @returns {object} the content's WidgetModel object
		 */
		getWidgetModel() {}

		/**
		 * @returns {object} The content's LayoutModel object
		 */
		getLayoutModel() {}

		/**
		 * @returns {object} A JS object representing the WidgetModel
		 */
		toJSON() {}
	}

	return InternalModelsAPI;
});
